The two-letter ISO 3166-1:2013 country code, in uppercase.
